import { useSelector } from 'react-redux'
import { selectNotificationPlanDetails } from '@/features/domain/territory'

export function useCommunicationPlanData() {
  return useSelector(selectNotificationPlanDetails)
}
